import React, { useEffect, Dispatch, SetStateAction, useState } from 'react'
import './styles.scss'
import { config } from './config'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import { languageType, localesInterface } from 'components/main/types'

interface Props {
  children: JSX.Element
  isactive?: boolean
  toggleActivation?: Dispatch<SetStateAction<boolean>> | Function
  getMap?: (map: InterfaceMapBox) => void | undefined
  language: languageType
  locales: localesInterface
}

export const MapboxGLMap = ({
  children,
  isactive = true,
  toggleActivation = () => {},
  language = 'de',
  locales,
  getMap
}: Props) => {
  const [zoom, setZoom] = useState(config.zoom)
  let map: InterfaceMapBox

  useEffect(() => {
    map = new mapboxgl.Map({
      container: 'map',
      center: config.center,
      style: language === 'de' ? config.style : config.style_fr,
      maxBounds: config.bounds,
      attributionControl: false,
      zoom: config.zoom,
      maxZoom: config.maxZoom,
      minZoom: config.minZoom
    })
    addAttribution(map, locales.attribution)
    addZoomControls(map)
    // activateOnZoom(map, toggleActivation, isactive)

    deactivateRotation(map)
    map.addImageToMap = (image, id) => {
      map.loadImage(image, function(err, image) {
        if (err) throw err
        map.addImage(id, image)
      })
    }
    map.on('style.load', () => {
      if (getMap) {
        getMap(map)
      }
    })
    map.on('move', () => {
      setZoom(map.getZoom())
    })
  }, [])

  return (
    <div className='ui vertical segment mapbox'>
      <div
        className={'mapboxglmap' + (isactive ? ' active' : ' inactive')}
        id='map'
      >
        {/* {zoom && <div className='infowindow'>{zoom}</div>} */}
        {children && <div className='mapoverlay'>{children}</div>}
      </div>
    </div>
  )
}
//
//
//
//
//
const deactivateRotation = (map: InterfaceMapBox) => {
  map.dragRotate.disable()
  map.touchZoomRotate.disableRotation()
}
const activateOnZoom: (
  map: InterfaceMapBox,
  activate: Dispatch<SetStateAction<boolean>> | Function,
  isactive: boolean
) => void = (map, activate, isactive) => {
  map.on('movestart', () => {
    console.log('AUTO ATCIVATE')
    if (!isactive) activate(true)
  })
}
const addAttribution: (
  map: InterfaceMapBox,
  attr?: string,
  location?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'
) => void = (map, attr = '', location = 'bottom-right') => {
  map.addControl(
    new mapboxgl.AttributionControl({
      customAttribution: attr
    }),
    location
  )
}
const addZoomControls: (
  map: InterfaceMapBox,
  location?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'
) => void = (map, location = 'top-right') => {
  map.addControl(new mapboxgl.NavigationControl(), location)
}
